import { writable, get } from "svelte/store"
import {
    getGeneralInformation,
    getEvents,
    getArticles,
    getFreeWeekendAppointments,
} from "./api"

const initLoc = {
    path: (typeof window !== "undefined" && window.location?.pathname) || "/",
    search: (typeof window !== "undefined" && window.location?.search) || "",
    push: false,
    pop: false,
    categoryPath: "",
}
initLoc.categoryPath = initLoc.path.replace(/\/\d{4,99}[^\/]+$/, "")

export const location = writable(initLoc)

///// AUTH

export const login = writable<Login>(null)

// General Information

export const generalInformation = writable<GeneralInformation>()
const getGeneralProjectInformation = async () => {
    const infos = await getGeneralInformation()
    generalInformation.set(infos[0])
}
getGeneralProjectInformation()

// Events

export const events = writable<Event[]>()
const getAllEvents = async () => {
    const list = await getEvents()
    events.set(list)
}
getAllEvents()

// Articles

export const articles = writable<SWArticle[]>()
const getAllArticles = async () => {
    const list = await getArticles()
    articles.set(list)
}
getAllArticles()

// Free Weekend Appointsments

export const free_weekend_appointments = writable<Appointment[]>()
const getAllFreeWeekendAppointments = async () => {
    const list = await getFreeWeekendAppointments()
    free_weekend_appointments.set(list)
}
getAllFreeWeekendAppointments()

// Cookies - Webmakers Cookie Bar

export const ccTags = writable<string[]>([])

const updateCcTtags = () => {
    // @ts-ignore
    ccTags.set(window.ccLoadedTags || [])
}

if (typeof window !== "undefined") {
    window.addEventListener("ccInit", updateCcTtags)
    window.addEventListener("ccAccept", updateCcTtags)
}
